package one.healthium.insights.ui.shopping_list.models

internal data class ShoppingItemUiModel(
    val id: String,
    val listId: String,
    val name: String,
    val emoji: String?,
    val quantity: String,
    val checked: Boolean,
    val categoryId: String?,
)
